import {
  getCustomerOrganizationName,
  getCustomerName,
  getAddressFromCustomerInfo
} from 'lib/notice/customer';
import {
  Customer,
  CustomerOrganization,
  EAddress,
  EOrganization,
  ERef,
  EUser,
  exists
} from 'lib/types';

type DefaultInvoiceRecipient = {
  name: string;
  email: string;
  mailingAddress: EAddress;
};

export const getDefaultInvoiceRecipient = async (
  filer: ERef<EUser>,
  filedBy: ERef<EOrganization> | null,
  customer: ERef<Customer> | null,
  customerOrganization: ERef<CustomerOrganization> | null
): Promise<DefaultInvoiceRecipient> => {
  let name = '';

  const filerSnap = await filer.get();
  const filedBySnap = await filedBy?.get();
  const customerSnap = await customer?.get();
  const customerOrgSnap = await customerOrganization?.get();

  /**
   * Default invoice recipient hierarchy:
   * 1. Customer organization
   * 2. Customer
   * 3. FiledBy
   * 4. Filer
   */

  // Prefer customer information over filer information
  if (exists(customerSnap) && exists(filerSnap)) {
    if (exists(customerOrgSnap) && exists(filedBySnap)) {
      // Prefer the actual advertiser organization name over customerOrganization name
      // This is to be in sync with invoice PDFs and payment pages,
      // which show the adv organization name rather than the customerOrg name
      name =
        filedBySnap.data().name ||
        getCustomerOrganizationName(customerOrgSnap, customerSnap);
    } else {
      name =
        customerSnap.data().organizationName ||
        getCustomerName(customerSnap, filerSnap, true);
    }
  } else {
    // If no customer exists, prefer the filedBy org name > filer name
    name =
      filedBySnap?.data()?.name ||
      filerSnap.data()?.organizationName ||
      filerSnap.data()?.name ||
      '';
  }

  return {
    name,
    email: filerSnap.data()?.email || '',
    mailingAddress: getAddressFromCustomerInfo(
      customerOrgSnap,
      customerSnap,
      filerSnap
    )
  };
};
